function Favorites() {
	return <main>Избранное</main>;
}

export default Favorites;
